import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from 'actions/utils';
import { ICommonResponseObject, IProfessionProforientationData } from 'api/types';
import { IReducers } from 'reducers';
import genericReducers from 'reducers/genericReducer';
import { connectReducers } from 'utils';

import { GET_PROFORIENTATION } from '../actions';

export type ProforientationState = ICommonResponseObject<IProfessionProforientationData | null>;

const initialState: ProforientationState = {
  content: null,
  loading: false,
};
const generic = genericReducers<ProforientationState>();
const proforientation: IReducers<ProforientationState> = {
  [GET_PROFORIENTATION[REQUEST]]: generic.get.request,
  [GET_PROFORIENTATION[SUCCESS]]: generic.get.success,
  [GET_PROFORIENTATION[FAILURE]]: generic.get.failure,
  [GET_PROFORIENTATION[INVALIDATE]]: generic.get.invalidate(initialState),
};

export default connectReducers(initialState, proforientation);
